import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Marketing short link — /g/<key>.
 * The wallet the visit is credited to lives server-side (the rotation's top
 * priority), so the URL we hand out carries only the campaign key and its tags.
 */
export default function GoLink() {
  const { key } = useParams();
  const [dead, setDead] = useState(false);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/utm/${encodeURIComponent(key)}`)
      .then(({ data }) => {
        if (!alive) return;
        const extra = window.location.search.replace(/^\?/, "");
        const path = data.path + (extra ? `&${extra}` : "");
        window.location.replace(path);
      })
      .catch(() => { if (alive) setDead(true); });
    return () => { alive = false; };
  }, [key]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-300"
      style={{ background: "radial-gradient(900px 500px at 60% -10%, rgba(124,58,237,0.18), transparent), #070B14" }}
      data-testid="go-link-page">
      {dead ? (
        <div className="text-center px-6" data-testid="go-link-dead">
          <p className="text-lg font-semibold text-white">This link isn&apos;t active</p>
          <p className="text-sm text-slate-400 mt-1">Ask whoever shared it for a fresh one.</p>
        </div>
      ) : (
        <Loader2 className="animate-spin" data-testid="go-link-loading" />
      )}
    </div>
  );
}
